module.exports = __webpack_public_path__ + "static/media/logo-color.c3589262.png";